export default __webpack_public_path__ + "6df13e3492405de8f1a875e414965ed3.ogg";